import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const AddressMiniIcon = () => (
    <svg width="16" height="16" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M32 4C19.85 4 10 13.85 10 26c0 17.15 22 34 22 34s22-16.85 22-34C54 13.85 44.15 4 32 4Z" fill="#FF4D00"/>
      <circle cx="32" cy="26" r="9" fill="#FFFFFF"/>
      <path d="M12 46h40l8 14H4l8-14Z" fill="#7CB342"/>
    </svg>
  );

  const WhatsAppMiniIcon = () => (
    <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="16" cy="16" r="16" fill="white"/>
      <path d="M16 2.5C8.44 2.5 2.5 8.44 2.5 16c0 2.42.63 4.8 1.82 6.92L2.5 29.5l7.65-2.3C13.13 29.35 15.5 29.5 16 29.5c7.56 0 13.5-5.94 13.5-13.5S23.56 2.5 16 2.5zm0 24c-1.62 0-3.17-.4-4.62-1.15l-.33-.18-3.42 1.02.98-3.55-.2-.33C5.4 19.2 5 17.61 5 16c0-6.06 4.94-11 11-11s11 4.94 11 11-4.94 11-11 11z" fill="#25D366"/>
      <path d="M22.67 19.4c-.33-.17-1.97-.97-2.28-1.08-.31-.1-.54-.16-.77.17-.23.33-.88 1.08-1.08 1.3-.19.23-.39.25-.72.09-.33-.16-1.41-.52-2.68-1.65-.99-.88-1.66-1.97-1.85-2.3-.19-.33-.02-.52.15-.68.15-.15.33-.39.5-.59.16-.19.22-.33.33-.55.11-.22.06-.41-.03-.58-.09-.17-.77-1.85-1.05-2.53-.27-.66-.54-.57-.77-.58h-.66c-.23 0-.61.09-.93.44-.32.35-1.22 1.19-1.22 2.9 0 1.72.96 3.38 1.1 3.62.14.24 1.93 3.6 4.64 5.06.64.34 1.14.55 1.53.71.64.25 1.23.21 1.69.13.52-.08 1.6-.65 1.83-1.28.22-.63.22-1.17.16-1.28-.07-.11-.28-.17-.59-.3z" fill="#25D366"/>
    </svg>
  );

  const CallMiniIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="#2CB34A" />
      <path
        d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.36 11.36 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.85 21 3 13.15 3 3a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2Z"
        fill="#FFFFFF"
      />
    </svg>
  );

  const EmailMiniIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="#2CB34A" />
      <path
        d="M6 8h12c0.55 0 1 0.45 1 1v6c0 0.55-0.45 1-1 1H6c-0.55 0-1-0.45-1-1V9c0-0.55 0.45-1 1-1Z"
        fill="#FFFFFF"
      />
      <path d="M6.3 8.7 12 12.8l5.7-4.1" stroke="#2CB34A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const WhatsAppIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="white"/>
      <path d="M16 2.5C8.44 2.5 2.5 8.44 2.5 16c0 2.42.63 4.8 1.82 6.92L2.5 29.5l7.65-2.3C13.13 29.35 15.5 29.5 16 29.5c7.56 0 13.5-5.94 13.5-13.5S23.56 2.5 16 2.5zm0 24c-1.62 0-3.17-.4-4.62-1.15l-.33-.18-3.42 1.02.98-3.55-.2-.33C5.4 19.2 5 17.61 5 16c0-6.06 4.94-11 11-11s11 4.94 11 11-4.94 11-11 11z" fill="#25D366"/>
      <path d="M22.67 19.4c-.33-.17-1.97-.97-2.28-1.08-.31-.1-.54-.16-.77.17-.23.33-.88 1.08-1.08 1.3-.19.23-.39.25-.72.09-.33-.16-1.41-.52-2.68-1.65-.99-.88-1.66-1.97-1.85-2.3-.19-.33-.02-.52.15-.68.15-.15.33-.39.5-.59.16-.19.22-.33.33-.55.11-.22.06-.41-.03-.58-.09-.17-.77-1.85-1.05-2.53-.27-.66-.54-.57-.77-.58h-.66c-.23 0-.61.09-.93.44-.32.35-1.22 1.19-1.22 2.9 0 1.72.96 3.38 1.1 3.62.14.24 1.93 3.6 4.64 5.06.64.34 1.14.55 1.53.71.64.25 1.23.21 1.69.13.52-.08 1.6-.65 1.83-1.28.22-.63.22-1.17.16-1.28-.07-.11-.28-.17-.59-.3z" fill="#25D366"/>
    </svg>
  );

  const CallIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M6.62 10.79a15.053 15.053 0 0 0 6.59 6.59l2.2-2.2c0.27-0.27 0.67-0.36 1.02-0.24 1.12 0.37 2.33 0.57 3.57 0.57 0.55 0 1 0.45 1 1V20c0 0.55-0.45 1-1 1C10.85 21 3 13.15 3 3c0-0.55 0.45-1 1-1h3.5c0.55 0 1 0.45 1 1 0 1.24 0.2 2.45 0.57 3.57 0.11 0.35 0.03 0.74-0.25 1.02l-2.2 2.2Z"
        fill="white"
      />
    </svg>
  );

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Taxi 24hrs</h3>
            <p className="footer-description">
              Your reliable taxi service available 24/7 for all your transportation needs.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#transfers">Airport Transfers</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><a href="#services">City Rides</a></li>
              <li><a href="#services">Airport Transfer</a></li>
              <li><a href="#services">Long Distance</a></li>
              <li><a href="#services">Corporate Rides</a></li>
            </ul>
          </div>

          <div className="footer-section contact-section">
            <h4 className="footer-heading">Contact Info</h4>
            <div className="footer-contact">
              <p className="contact-item">
                <span className="contact-label address-label">
                  <span className="contact-label-icon">
                    <AddressMiniIcon />
                  </span>
                </span>
                <span>London, United Kingdom</span>
              </p>
              <p className="contact-item">
                <span className="contact-label call-label">
                  <span className="contact-label-icon">
                    <CallMiniIcon />
                  </span>
                </span>
                <a href="tel:02038393300">+44 203 839 3300</a>
              </p>
              <p className="contact-item">
                <span className="contact-label whatsapp-label">
                  <span className="contact-label-icon">
                    <WhatsAppMiniIcon />
                  </span>
                </span>
                <a href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer">+44 736 587 4733</a>
              </p>
              <p className="contact-item">
                <span className="contact-label email-label">
                  <span className="contact-label-icon">
                    <EmailMiniIcon />
                  </span>
                </span>
                <a href="mailto:info@taxi-24hrs.co.uk">info@taxi-24hrs.co.uk</a>
              </p>
            </div>
          </div>
        </div>

        <div className="footer-social">
          <a href="tel:02038393300" className="social-icon call-icon" title="Call us">
            <CallIcon />
          </a>
          <a href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp-icon" title="WhatsApp">
            <WhatsAppIcon />
          </a>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Taxi 24hrs. All rights reserved.</p>
          <div className="footer-bottom-links">

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
